import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=ef721f28&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports